module.exports = __webpack_public_path__ + "static/media/35514119_1946624322028162_867456769566179328_o.54c0a547.jpg";